import React from "react";
import { FiX } from "react-icons/fi";
import { TbLoader2 } from "react-icons/tb";
import DeclineModal from "../../PaymentSetup/Components/DeclineModal";

export const SurveyDeclineModal = ({
  openModal,
  setOpenModal,
  closeModal,
  handleComment,
  handleDelete,
  isLoading,
  title = "Reason for Decline",
  extra = null,
  disabled = false
}) => {
  return (
    <div>
      {openModal && (
        <DeclineModal hideModal={setOpenModal}>
          <div
            className="bg-white w-full overflow-hidden"
            style={{ borderTopLeftRadius: "5px", borderTopRightRadius: "5px" }}
          >
            <header className="w-full py-3 bg-customGreen px-4 flex items-center justify-between">
              <p className="text-white text-baseFont">{title}</p>
              {!isLoading ? (
                <button
                  className="text-baseFont text-white"
                  onClick={closeModal}
                >
                  <FiX />
                </button>
              ) : (
                <TbLoader2 className="text-white animate-spin" />
              )}
            </header>
            {/*main*/}
            <div
              className="flex items-start justify-between gap-3 w-full px-7 py-7"
              style={{ borderBottom: "1px solid #ccc" }}
            >
              <textarea
                cols={"15"}
                rows={"5"}
                placeholder="Enter a comment..."
                onChange={handleComment}
                className="text-xs border border-slate-300 rounded w-full p-2 outline-none focus:ring-0 focus:border-customGreen"
              />
            </div>
            {extra && <div className="px-7 py-3">{extra}</div>}
            {/*main*/}
            <div className="w-full flex items-center justify-end gap-5 pt-3 px-7">
              <button
                className="rounded-md py-1 px-4 text-baseFont text-customGreen"
                style={{ border: "1px solid #305f32" }}
                onClick={closeModal}
              >
                Cancel
              </button>
              <button
                className="bg-customGreen rounded-md py-1 px-4 text-white text-baseFont"
                style={{ border: "1px solid #305f32" }}
                onClick={handleDelete}
                disabled={isLoading || disabled}
              >
                {isLoading ? "Declining..." : "Decline"}
              </button>
            </div>
          </div>
        </DeclineModal>
      )}
    </div>
  );
};
